module.exports = __webpack_public_path__ + "static/img/TH.e34a9050.svg";